import {
  ApartmentOutlined,
  CheckCircleFilled,
  FilterOutlined,
  TableOutlined,
  UndoOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tooltip, Button, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GetFilteredUnitPerformanceApi from "../../api/units/GetFilteredUnitPerformanceApi";
import GetUnitsPerformanceApi from "../../api/units/GetUnitsPerformanceApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import UnitPerformanceFilterModal from "../../components/modal/filters/UnitPerformanceFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import UnitsTable from "../../components/tables/UnitsTable";
import UnitsTree from "../../components/tree/UnitsTree";
// import { LIMIT_PER_PAGE } from "../../helpers/constants";

function Units() {
  const [canStart, setCanStart] = useState(false);
  const [data, setData] = useState();
  const [tree, setTree] = useState(false);
  const [page, setPage] = useState(1);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const pageLimit = 40;

  let navigate = useNavigate();

  useEffect(() => {
    getUnits(1);
  }, [perfCycleState]);

  async function getUnits(num) {
    setTableLoading(true);
    const apiResponse = await GetUnitsPerformanceApi(
      perfCycleState.id,
      num,
      positionState.id,
      pageLimit
    );

    if (apiResponse.success) {
      setData(apiResponse.data);
      setCanStart(true);
      setTableLoading(false);
      setPage(num);
    }
  }

  async function getFilteredUnitPerformance(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredUnitPerformanceApi(
      perfCycleState.id,
      values.name || "",
      values.organizationLevel || "",
      num,
      positionState.id,
      pageLimit
    );
    if (apiResponse.message === "success") {
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterStatus(true);
      setFilterBy({
        unitName: values.unitName,
        organizationLevel: values.organizationLevel,
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilteredUnitPerformance(filterBy, num);
    } else {
      getUnits(num);
    }
  }

  function resetFilter() {
    setFilterStatus(false);
    getUnits(1);
    setFilterBy();
  }

  const right = (
    <>
      {canStart && !tree && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">Units</div>
      {canStart &&
        (tree ? (
          <Tooltip title={"Table view"}>
            <Button onClick={() => setTree(false)} className="ml-3">
              <TableOutlined />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title={"Tree view"}>
            <Button onClick={() => setTree(true)} className="ml-3">
              <ApartmentOutlined />
            </Button>
          </Tooltip>
        ))}
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            tree ? (
              <UnitsTree />
            ) : (
              <UnitsTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <UnitPerformanceFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilteredUnitPerformance(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default Units;
